inputs-checkbox-fade-in
  .checkbox-fade.fade-in-primary
    label
      input(type="hidden" value="0" name="{ opts.name }")
      input(type="checkbox" value="1" name="{ opts.name }")
      span.cr
        i.cr-icon.icofont.icofont-ui-check.txt-primary
      span { opts.label }
  script(type="typescript").
    this.mixin('inputs.checkbox-fade-in')
